import { Fragment } from 'react';

import { Spinner } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { SchemaForm } from '../schema/form/schema-form';
import { useCarrierContractSchemaQuery } from '../schema/queries';

interface Props {
  schemaId: string;
}

export function Configuration({ schemaId }: Props) {
  const { data: schema, isLoading } = useCarrierContractSchemaQuery(schemaId);
  const { t } = useTranslation();

  if (isLoading || !schema) {
    return <Spinner />;
  }

  return (
    <Fragment>
      <p style={{ color: 'var(--grey-66)', margin: 0 }}>{t('carrierContracts.create.helpText')}</p>

      {Object.entries(schema.json_schema).map(([key, value]) => (
        <SchemaForm schema={value} schemaId={schemaId} key={key} path={`carrier_configuration_data.${key}`} />
      ))}
    </Fragment>
  );
}
